import { useEffect, useState } from 'react';
import { AppShell } from '@/components/layout/AppShell';
import { api, parseErr } from '@/lib/api';
import { toast } from 'sonner';
import { fmtDateTime, shortId } from '@/lib/format';
import { Input } from '@/components/ui/input';

export default function AdminAuditPage() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => { api.get('/audit', { params: { limit: 300 } }).then(r => setRows(r.data || [])).catch(e => toast.error(parseErr(e))); }, []);
  const shown = rows.filter(r => !filter || JSON.stringify(r).toLowerCase().includes(filter.toLowerCase()));

  return (
    <AppShell breadcrumbs={[{ label: 'Admin', to: '/admin/users' }, { label: 'Audit Log' }]}>
      <div className="p-6 max-w-[1200px] mx-auto" data-testid="admin-audit-page">
        <h1 className="font-heading text-2xl font-semibold">Audit Log</h1>
        <p className="text-[13px] text-[hsl(var(--foreground-muted))]">Append-only. Every state-changing action is captured.</p>
        <div className="mt-3 max-w-md">
          <Input placeholder="Filter by actor, action, entity…" value={filter} onChange={e => setFilter(e.target.value)} data-testid="audit-filter" />
        </div>
        <div className="mt-4 border rounded-xl bg-[hsl(var(--card))] overflow-x-auto" style={{ borderColor: 'hsl(var(--border))' }} data-testid="audit-log">
          <table className="tbl">
            <thead><tr><th>Time</th><th>Actor</th><th>Action</th><th>Entity</th><th>Entity Id</th><th>Details</th></tr></thead>
            <tbody>
              {shown.map(r => (
                <tr key={r.id} data-testid="audit-log-item">
                  <td className="text-[12px] font-mono text-[hsl(var(--foreground-muted))]">{fmtDateTime(r.created_at)}</td>
                  <td className="text-[12.5px]">{r.actor_email || '—'}</td>
                  <td className="text-[12.5px]"><span className="chip">{r.action}</span></td>
                  <td className="text-[12.5px]">{r.entity}</td>
                  <td className="font-mono text-[11.5px] text-[hsl(var(--foreground-muted))]">{shortId(r.entity_id)}</td>
                  <td className="font-mono text-[11.5px] text-[hsl(var(--foreground-muted))] max-w-[300px] truncate">{JSON.stringify(r.after || r.before || r.meta || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}
